module.exports = __webpack_public_path__ + "img/cross.af1ed8b6.svg";